/**
 * Control keywords that should bypass Casper Run Card routing entirely.
 * When the user's trimmed, lowercased message exactly matches one of these,
 * Casper treats it as a control action (not a task to route).
 */
export const CASPER_CONTROL_KEYWORDS = Object.freeze([
  "skip",
  "cancel",
  "stop",
  "back",
  "next",
  "nevermind",
]);

/**
 * Returns true if the given message is a control keyword that should
 * bypass the Run Card router entirely.
 */
export function isCasperControlKeyword(message) {
  if (!message || typeof message !== "string") return false;
  return CASPER_CONTROL_KEYWORDS.includes(message.trim().toLowerCase());
}
